module.exports = __webpack_public_path__ + "static/media/instluminarias3.39078594.jpg";